import React from 'react'

import FieldFormElement from "../../../fields3/render/form-elemnent"
import FormModel from "../../../gd-form/common/form-model-manager"
import FormManager from "../../../gd-form/common/form-manager"
import TimeReport from "../../../model2/time-report/time-report"
import Textarea from "../../../gd-form/form-element/textarea/textarea"
import ErrorBoundary from "../../../error-boundary"
import ApiTimeReport from "../../../gd/api/time-reports/time-report"
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {ModalCreateTimeReportProps} from "./modal-create-time-report"
import Button, {ButtonSize, ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import ButtonSubmit from "../../../gd-form/common/btn-submit/btn-submit-ui5-new"
import InfoPanelRow from "../../../gd-ui/ip-section-row/info-panel-row"
import TimeReportEntityRow from "../../../gd-ui/time-report-entity-row/entity-row"

type Props = {
    className?  : string

    params      : ModalCreateTimeReportProps

    callback    : callback
}

export default class ModalNewTimeReport_Form extends React.Component<Props> {

    private readonly form       : FormModel
    private readonly commentForm: FormManager
    private timeReport          : TimeReport

    constructor(props: Props) {
        super(props)

        this.timeReport = new TimeReport({
            userId      : _.get(props.params, 'userId', gd.user.id),
            date        : _.get(props.params, 'date', moment()),
            task        : this.props.params.task,
            taskId      : this.props.params.task?.id,
            meeting     : this.props.params.meeting,
            meetingId   : this.props.params.meeting?.id,
            taskMessageId       : _.get(props.params, 'taskMessageId', null),

            reportedTimeMinutes : _.get(props.params, 'reportedTimeMinutes', undefined),
            startMoment         : _.get(props.params, 'startMoment', undefined),
            endMoment           : _.get(props.params, 'endMoment', undefined)
        })

        this.form = new FormModel(this.timeReport,{
            onSubmit        : this.onSubmit,
        })

        this.commentForm = new FormManager(
            {
                fields: {
                    comment : {
                        type        : 'input',
                        isRequired  : false
                    },
                }
            },
            {
                comment : null,
            }
        )

        this.form.onFieldChanged(gd.fields.timeReport.startMoment.fieldId,()=>{
            this.forceUpdate()
        })
        this.form.onFieldChanged(gd.fields.timeReport.endMoment.fieldId,()=>{
            this.forceUpdate()
        })

        this.form.onFieldChanged(gd.fields.timeReport.reportedTime.fieldId,()=>{
            this.forceUpdate()
        })

    }

    public onSubmit = async () => {

        const comment = this.commentForm.getValue('comment') || null
        this.timeReport.commentTxt = comment
        this.timeReport.message    = comment

        let response : any

        if (this.timeReport.taskMessageId) {
            response = await ApiTimeReport.createForTaskMessage(
                this.timeReport.taskMessageId,
                this.timeReport.reportedTimeMinutes,
                // @ts-ignore
                this.timeReport.startMoment,
                this.timeReport.endMoment
            )

        } else {
            const needMyTimeResponse : boolean =  _.get(this.props.params, 'needMyTimeResponse', false)

            response = await ApiTimeReport.create(this.timeReport, needMyTimeResponse)
        }

        if (_.isNil(response.conflictResponse)){
            // IMPORTANT
            // hide modal here only if we have NO conflict
            // as it will close conflict modal as well
            gd.modal.hide()
        }

        if (this.props.callback) this.props.callback(response, this.timeReport)
    }

    public reRender = () => {
        this.forceUpdate()
    }

    cancelTimer = () => {
        this.props.params.timer!.cancel()
    }


    render() {

        return (
            <div className="iv-content with-left-panel">

                <div className="ui5-title-app-name m-l-40 m-t-15 m-b-15 lh-30">New Time Report</div>

                <VScroll className="content-scroll">
                    <div className  = "ui5-info-panel big-panel h-unset m-l-15 m-r-15"
                         style      = {{
                             minHeight: "calc(100% - 20px)"
                         }}
                    >

                        <div className="ip-section">
                            <ErrorBoundary>
                                <InfoPanelRow label="Time reported">
                                    <FieldFormElement
                                        className   = "w-300"
                                        field       = {gd.fields.timeReport.reportedTime}
                                        form        = {this.form}
                                        model       = {this.timeReport}
                                        options     = {{displayStartEnd: false}}
                                    />
                                </InfoPanelRow>
                            </ErrorBoundary>

                            {!this.timeReport.taskMessageId &&
                                <InfoPanelRow label="Report date">
                                    <FieldFormElement
                                        className   = "w-300"
                                        field       = {gd.fields.timeReport.date}
                                        form        = {this.form}
                                    />
                                </InfoPanelRow>
                            }

                            <InfoPanelRow label="Start-end time">
                                <FieldFormElement
                                    className   = "w-140"
                                    field       = {gd.fields.timeReport.startMoment}
                                    form        = {this.form}
                                    model       = {this.timeReport}
                                />
                                <div className="w-20 flex-row-center-center ui5-txt-not-important">-</div>
                                <FieldFormElement
                                    className   = "w-140"
                                    field       = {gd.fields.timeReport.endMoment}
                                    form        = {this.form}
                                    model       = {this.timeReport}
                                />
                            </InfoPanelRow>

                            {gd.modules.timeTracking.isBillableTimeEnabled &&
                                <InfoPanelRow label={gd.fields.timeReport.isBillable.label}>
                                    <FieldFormElement
                                        className   = "w-300"
                                        field       = {gd.fields.timeReport.isBillable}
                                        form        = {this.form}
                                    />
                                </InfoPanelRow>
                            }
                        </div>

                        <div className="ip-section m-t-10">
                            <div className="ui5-title-small m-l-25 m-b-10">System information</div>

                            <TimeReportEntityRow timeReport={this.timeReport}/>

                            {!this.timeReport.taskMessageId && !this.props.params.timer &&
                                <InfoPanelRow label="Reported by">
                                    <FieldFormElement
                                        className   = "w-300"
                                        field       = {gd.fields.timeReport.userId}
                                        form        = {this.form}
                                        model       = {this.timeReport}
                                    />
                                </InfoPanelRow>
                            }

                            {!this.timeReport.taskMessageId &&
                                <div className="time-report-message m-l-25 m-t-20 m-r-25">
                                    <div className="ui5-title-small m-b-10">Comments</div>
                                    <div className="info-block-content">
                                        <div className  = "message-textarea-wrapper is-editing"
                                             style      = {{
                                                 width: 460
                                             }}
                                        >
                                            <Textarea
                                                form        = {this.commentForm}
                                                name        = "comment"
                                                placeholder = "Add a comment..."
                                                size        = "big"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            <InfoPanelRow className="m-t-10 m-b-30">
                                <ButtonSubmit
                                    className   = "w-125"
                                    form        = {this.form}
                                    size        = {ButtonSize.STANDARD}
                                    label       = "Submit"
                                />

                                {this.props.params.timer &&
                                    <Button
                                        type        = {ButtonType.SECONDARY_RED}
                                        size        = {ButtonSize.STANDARD}
                                        onClick     = {this.cancelTimer}
                                        label       = "Cancel Timer"
                                        className   = "m-l-20 w-125"
                                    />
                                }
                            </InfoPanelRow>
                        </div>
                    </div>
                </VScroll>
            </div>
        )
    }
}
